var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElevatorIcon = function SvgElevatorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.7 10.415a.365.365 0 0 0-.516 0l-.731.73a.365.365 0 1 0 .517.517l.73-.73a.365.365 0 0 0 0-.517"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m20.431 11.146-.73-.731a.365.365 0 1 0-.517.516l.73.731a.364.364 0 0 0 .517 0 .365.365 0 0 0 0-.517M20.431 13.337a.365.365 0 0 0-.516 0l-.731.731a.365.365 0 1 0 .516.517l.731-.731a.365.365 0 0 0 0-.517"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.7 14.068-.73-.73a.365.365 0 1 0-.517.516l.73.73a.364.364 0 1 0 .517-.516"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M10.5 2.5v18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M3 20.8h15.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M4 20.5V3a.5.5 0 0 1 .5-.5H17a.5.5 0 0 1 .5.5v17.5"
  })));
};
export default SvgElevatorIcon;